
























































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { directusApi } from '@/api';
import { asyncForEach, validateStatusOrders } from '@/utils';
import _ from 'lodash';
import { Spinner } from 'vue-image-spinner2';
import moment from 'moment-timezone';

@Component({
    name: 'message-modal',
    components: {
        Spinner,
    },
    computed: {
        ...mapState('messages', ['activeMessageLoading', 'activeMessage']),
        ...mapState('messages', {
            activeMessage: (state: any) => {
                // console.log(state.activeMessage.order_status);
                state.activeMessage.order_status = validateStatusOrders('Sinenvío', state.activeMessage.order_status);
                const conversation = state.activeMessage.conversation.map((message: any) => {
                    console.log(message.message_date.available);
                    console.log(message);

                    console.log(' ---------- ', moment(message.message_date.available).format('YYYY-MM-DD HH:mm:ss'));
                });
                // console.log(state.activeMessage.order_status);

                return state.activeMessage;
                // const allOrders = state.allOrders.map((order: any) => {
                // return {
                //     ...order,
                //     permalink: `https://www.mercadolibre.com.mx/ventas/${order.id}/detalle`,
                //     logistic_type,
                //     // status,
                //     tags: status_order,
                //     delivery_info: infoCollect,
                //     delay_info,
                //     // variant: status_variant
                // };
            },
        }),
    },
})
export default class MessageModal extends Vue {
    //
    private activeMessage!: any;
    private activeMessageLoading!: any;

    private searchQuery: string = '';
    public dataPdf: any = '';
    public pdfSrc: string = '';
    public products_order: any = [];
    public fields_product_order: any = ['id', 'qty', 'price'];

    public saleDetail: any = [];
    public fields_sale_detail: any = ['title', 'sale_fee'];

    public totalOrder: any = 0;
    public amountOrder: any = 0;
    public shipmentCostOrder: any = 0;
    public shippingCostBuyer: any = 0;
    public mlpublications = [];

    private activeLocation!: any;
    private activeLocationLoading!: any;
    public stopLocation = 0;

    package_manager_options: any = [
        { value: null, text: 'Encargado', disabled: true },
        { value: 'Jonathan', text: 'Jonathan' },
        { value: 'Jaime', text: 'Jaime' },
        { value: 'Erick', text: 'Erick' },
        { value: 'Alejandro', text: 'Alejandro' },
        { value: 'Rigoberto', text: 'Rigoberto' },
        { value: 'Alejandra', text: 'Alejandra' },
    ];
    // public intelisis_movement: string = '';

    get permalink() {
        // return `https://www.mercadolibre.com.mx/ventas/${this.activeMessage.id}/detalle`; (node-api)
        if (this.activeMessage.intelisis_movement == 'Sin asignar') {
            this.activeMessage.intelisis_movement = '';
        }
        return `https://www.mercadolibre.com.mx/ventas/${this.activeMessage.id}/detalle`;
    }

    getOrderUrl(id: string) {
        return `https://prodelec.mx/wp-admin/post.php?post=${id}&action=edit&classic-editor`;
    }

    // mounted() {
    // 	// // setTimeout(() => {
    // 	// this.activeMessage.order_items = JSON.parse(this.activeMessage.order_items);
    // 	// // }, 1000);
    // }
    formattedDate(myDate) {
        return moment(myDate).format('DD/MM/YYYY HH:mm:ss');
    }

    downloadFile(file: any, store: string, order_id: string) {
        console.log(file);
        
        console.log('...');
        window.open(
            `https://www.mercadolibre.com.mx/api/messages/packs/${order_id}/sellers/430774329/messages/attachments/${file.filename}?siteId=MLM&tag=post_sale`,
            '_blank'
        );
        // https://www.mercadolibre.com.mx/api/messages/packs/2000003815198521/sellers/430774329/messages/attachments/430774329_2d2d9237-95e9-4f9f-8632-c0029fb46085.jpg?siteId=MLM
        // this.$store.dispatch('messages/downloadFile', {
        //     file,
        //     store,
        // });
    }

    onSaveOrder() {
        if (this.activeMessage.intelisis_movement == 'null' || this.activeMessage.intelisis_movement == '') {
            this.activeMessage.intelisis_movement == 'null';
        }
        this.$store.dispatch('messages/putOne', {
            // id: this.activeMessage.id, (node-api)
            vm: this,
            id: this.activeMessage.id,
            intelisis_movement: this.activeMessage.intelisis_movement,
            comments: this.activeMessage.comments,
            products: this.products_order,
            logistic_type: this.activeMessage.logistic_type,
            credit_note: this.activeMessage.credit_note,
            package_manager: this.activeMessage.package_manager,
            splitted_order: this.activeMessage.splitted_order,
            balance: this.activeMessage.balance,
        });
    }
}
